export default "__VITE_ASSET__8807e18e__"